import { createContext } from 'use-context-selector';
import { createProvider } from 'domain/createProvider';
import { TUpdate } from 'domain/types';
import { PROFILE_NOTIFICATIONS_PER_PAGE } from 'view/pages/profile/hooks/useGetProfileNotifications';

export type TGlobalConfigContextState = {
  currentEmail: string;
  userData: any;
  jobPostIdToActive: number | null;
  jobPostIdToDraft: number | null;
  jobPostIdToDelete: number | null;
  isReady: boolean;
  isShowMatchScore: boolean;
  isOpenDeleteJobPostModal: boolean;
  isOpenMoveJobPostToDraftModal: boolean;
  isOpenMoveJobPostToActiveModal: boolean;
  isOpenRecruiterStartConversationModal: boolean;
  isOpenRecruiterDenyCandidateModal: boolean;
  isOpenRecruiterApproveCandidateModal: boolean;
  isOpenOnboardingWizard: boolean;
  messages: any;
  profileNotificationsData: any;
  unreadNotificationsCount: number;
  hasUnreadMessages: boolean;
  update?: TUpdate<TGlobalConfigContextState>;
};

const initState: TGlobalConfigContextState = {
  currentEmail: '',
  userData: {},
  jobPostIdToActive: null,
  jobPostIdToDraft: null,
  jobPostIdToDelete: null,
  isReady: false,
  isShowMatchScore: false,
  isOpenDeleteJobPostModal: false,
  isOpenMoveJobPostToDraftModal: false,
  isOpenMoveJobPostToActiveModal: false,
  isOpenRecruiterStartConversationModal: false,
  isOpenRecruiterDenyCandidateModal: false,
  isOpenRecruiterApproveCandidateModal: false,
  isOpenOnboardingWizard: false,
  messages: [],
  profileNotificationsData: {
    data: [],
    limit: PROFILE_NOTIFICATIONS_PER_PAGE,
    page: 1,
    total: 0,
  },
  unreadNotificationsCount: 0,
  hasUnreadMessages: false,
};

export const GlobalConfigContext = createContext<TGlobalConfigContextState>(initState);

export const GlobalConfigProvider = createProvider(GlobalConfigContext, initState);
